module.exports = __webpack_public_path__ + "media/svg/zw-a53613c5.svg";